import Link from 'next/link';
import styled from 'styled-components';
import Url from 'lib/siteurls';
import { mqXLargeMin, mqSmallMax } from 'styled/tools/media-queries';
import { Fontw35s48h56, Fontw4s16h24, Fontw4s24h32 } from 'styles/commonCss';
import ChatBubbleIcon from './ChatBubbleIcon';
import MicrobiomeIllustration from './MicrobiomeIllustration';
import Icon from 'components/global/Icon/Primary';
import { trackLinkClicked } from 'lib/analytics';

const Container = styled.div`
  background-color: var(--fill-secondary);
  padding: 72px 48px 72px 48px;

  @media ${mqSmallMax} {
    padding: 48px 24px 48px 24px;
  }
`;

const Section = styled.section`
  display: flex;

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: row;
  line-height: normal;
  width: 50%;
  margin-left: 0px;
  gap: 48px;

  @media (max-width: 991px) {
    width: 100%;
    flex-direction: column;
  }
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: row;
  line-height: normal;
  width: 50%;
  margin-left: 0px;
  gap: 48px;

  @media (max-width: 991px) {
    width: 100%;
    flex-direction: column;
    padding-top: 24px;
    margin-top: 48px;
  }
`;

const Title = styled.h1`
  ${Fontw35s48h56}
  color: var(--text-primary);
  letter-spacing: -0.48px;
`;

const Description = styled.p`
  ${Fontw4s16h24}
  color: var(--text-primary);
  margin-top: 24px;

  .lt-break {
    display: none;
  }

  @media ${mqSmallMax} {
    margin-top: 12px;
  }

  @media (${mqXLargeMin}) {
    .lt-break {
      display: block;
    }
  }
`;

const CardWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

const CardTitle = styled.div`
  ${Fontw4s24h32}
  align-self: stretch;
  margin-top: 24px;
`;

const CardDescription = styled.div`
  ${Fontw4s16h24}
  align-self: stretch;
  margin-top: 24px;
`;

const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  color: var(--outline-primary);

  @media ${mqSmallMax} {
    margin-bottom: 24px;
  }
`;

const trackLinkClick = () => {
  trackLinkClicked(
    'Email to HCP',
    Url.email_practitioners,
    '/practitioners',
    '/practitioners',
    window.location.href,
  );
};

const GrowWithSeed = () => (
  <Container>
    <Section>
      <LeftColumn>
        <CardWrapper>
          <Title>Grow with Seed</Title>
          <Description>
            Our resources and healthcare education are designed to empower&nbsp;
            <br className='lt-break' />
            practitioners across the patient journey.
          </Description>
        </CardWrapper>
      </LeftColumn>
      <RightColumn>
        <CardWrapper>
          <MicrobiomeIllustration />
          <CardTitle>
            Enrich Your Microbiome
            <br /> Education
          </CardTitle>
          <CardDescription>
            With a deep commitment to education and to providing actionable
            insights, we translate foundational concepts, our latest research,
            and discoveries from the frontlines of microbiome science.
          </CardDescription>
          <LinkWrapper>
            <Icon name='arrow-right' size='lg' />
            <Link prefetch={false} href='#form-hcp'>
              Sign up for Education
            </Link>
          </LinkWrapper>
        </CardWrapper>
        <CardWrapper>
          <ChatBubbleIcon />
          <CardTitle>
            Connect with our
            <br /> Practitioner Team
          </CardTitle>
          <CardDescription>
            The skilled clinicians on our team are here to answer your questions
            and provide the information you need to make important patient
            decisions. We collaborate closely with our R+D team to provide
            clinician-to-clinician responses.
          </CardDescription>
          <LinkWrapper>
            <Icon name='arrow-right' size='lg' />
            <a href={Url.email_practitioners} onClick={trackLinkClick}>
              Connect with Clinical Specialists
            </a>
          </LinkWrapper>
        </CardWrapper>
      </RightColumn>
    </Section>
  </Container>
);

export default GrowWithSeed;
